import { Box } from "@mui/system";
import { forwardRef } from "react";
import { Typography } from "@mui/material";
import { buildClass } from "@utils/tag";
import { Icon } from "@utils/helper";

const UploaderInput = forwardRef(
  (
    {
      name,
      onChange,
      label,
      disabled,
      helperText,
      single,
      accept,
      otherSx,
      additionalStyles,
    },
    ref
  ) => {
    const handleKeyEnter = (e) => {
      if (e.key === "Enter") {
        document.getElementById(name).click();
      }
    };
    return (
      <label
        htmlFor={name}
        className={buildClass("mt-1 sm:mt-0 cursor-pointer", {
          "w-fit": otherSx,
        })}
      >
        <Box
          tabIndex={0}
          onKeyDown={handleKeyEnter}
          className="flex justify-center p-2 min-h-[49px] focus:border-[2px] hover:border-[2px] focus:outline-0 transition-all duration-300 ease-in-out"
          sx={
            otherSx
              ? { ...otherSx }
              : { ...styles.mainContainer, ...additionalStyles }
          }
        >
          <div
            className={`flex justify-center items-center ${label && "gap-2"}`}
          >
            <Icon
              id="plus"
              width={10}
              height={10}
              viewBox="0 0 10 10"
              color="#0366FF"
            />
            <Typography
              color="#0366FF"
              variant="body1"
              className="text-center !text-base !font-Expo_bok "
            >
              {label}
            </Typography>
          </div>
          <div className="flex">
            <input
              disabled={disabled}
              type="file"
              id={name}
              name={name}
              ref={ref}
              onChange={onChange}
              multiple={!single}
              className="hidden"
              accept={accept}
            />
          </div>
        </Box>
        {helperText ? (
          <Typography className="!text-[12px] text-[#d32f2f] !mt-2 !ml-0 !mr-0 pt-2 px-2">
            {helperText}
          </Typography>
        ) : null}
      </label>
    );
  }
);

const styles = {
  mainContainer: {
    border: 1,
    borderColor: "#2B64F5",
    borderStyle: "dashed",
    borderRadius: "10px",
  },
};

UploaderInput.displayName = "UploaderInput";

export default UploaderInput;
